(function($){

  $(document).ready(function() {

      $('html').addClass('add-overflow');

  });

  $(document).on('click','#swiper-membership-benefits-section .swiper-pagination-bullet',function(){

    if (window.matchMedia("(max-width: 768px)").matches) {
      var offsetValue = 120;
    } else {
      var offsetValue = 240;
    }

    $('html, body').animate({
      scrollTop: $("#swiper-membership-benefits-section").offset().top - offsetValue
    }, 500);

  });

})(jQuery);

